import { getWhiteListGeneralUrl, getWhiteListTargets } from "services/baseUrl";
import { ConditionName, IEnvironment } from "../interfaces";
import { conditions } from "./conditions/conditions";

export const whiteListTargets = getWhiteListTargets() ? getWhiteListTargets().split(",") : [];

export const whiteListGeneralUrl = getWhiteListGeneralUrl() ? getWhiteListGeneralUrl().split(",") : [];

export const ENVIRONMENT: IEnvironment = {
    reduxDevTool: true
};

export const activeElementsTime = 3000;

export const showLoaderTime = 3000;

export const livePlayRetryDuration = 3000;

export const RetryCountGeneralDataFetch = 3;

export const RetryTimeDelayGeneralDataFetch = 5;

export const durationWatched = 60;

export const continuousePlaybackIntervalTime = 60000;

export const footerPadding = () => {
    if (conditions(ConditionName.footerPaddingZero)) return 0;
    else return 64;
};

export const featureToggle = "ft";

export const sidebarWidth = 357;
